"use client";

import { useContext } from "react";
import { BlockEditor } from "novels";
import { EditorContext } from "../../context/EditorContext";
import { Editor } from "@tiptap/react";

export const NovelsEditor = () => {
  const { setEditor, saveStatus, setSaveStatus } = useContext(EditorContext);
  return (
    <div className="relative w-full max-w-screen-lg">
      <div className="absolute right-16 top-5 z-10 mb-5 rounded-lg bg-stone-100 px-2 py-1 text-sm text-stone-400 lg:right-5">
        {saveStatus}
      </div>
      <BlockEditor
        onUpdate={(editor: Editor) => {
          setEditor(editor);
          setSaveStatus("Unsaved");
        }}
        onDebouncedUpdate={() => {
          setSaveStatus("Saving...");
          // Simulate a delay in saving.
          setTimeout(() => {
            setSaveStatus("Saved");
          }, 500);
        }}
      />
    </div>
  );
};
